import { useState } from "react";
import API from "../api";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    userType: "",
    sector: "",
    role: ""
  });

  const submit = async () => {
    await API.post("/auth/register", {
      ...form,
      sector: [form.sector]
    });

    alert("Registered Successfully");
    navigate("/login");
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6">
          Create Account 🚀
        </h2>

        <input
          placeholder="Name"
          className="w-full border p-2 rounded mb-3"
          onChange={e => setForm({ ...form, name: e.target.value })}
        />

        <input
          placeholder="Email"
          className="w-full border p-2 rounded mb-3"
          onChange={e => setForm({ ...form, email: e.target.value })}
        />

        <input
          type="password"
          placeholder="Password"
          className="w-full border p-2 rounded mb-3"
          onChange={e => setForm({ ...form, password: e.target.value })}
        />

        <select
          className="w-full border p-2 rounded mb-3"
          onChange={e => setForm({ ...form, userType: e.target.value })}
        >
          <option>User Type</option>
          <option>Startup</option>
          <option>Corporate</option>
          <option>Investor</option>
          <option>Advisor</option>
          <option>R&D</option>
        </select>

        <select
          className="w-full border p-2 rounded mb-3"
          onChange={e => setForm({ ...form, sector: e.target.value })}
        >
          <option>Sector</option>
          <option>Green Hydrogen</option>
          <option>Green Buildings</option>
          <option>Sustainable Agriculture</option>
        </select>

        <select
          className="w-full border p-2 rounded mb-4"
          onChange={e => setForm({ ...form, role: e.target.value })}
        >
          <option>Role</option>
          <option>Upstream</option>
          <option>Downstream</option>
        </select>

        <button
          onClick={submit}
          className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600"
        >
          Register
        </button>

        <p className="text-sm text-center mt-4">
          Already have an account?{" "}
          <Link to="/login" className="text-green-600 font-semibold">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}